var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "21C88B65-8D72-44BD-A1CF-AFE5FCCF1803") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-238.000000, -740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-5",
    transform: "translate(238.000000, 740.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.8302353,16.9685885 L9.33518022,13.8486415 C8.91230265,13.3524188 8.24003575,13.3524188 7.81715818,13.8486415 C7.39428061,14.3448641 7.39428061,15.1337309 7.81715818,15.6299536 L11.0603813,19.627833 C11.4832589,20.1240557 12.1663688,20.1240557 12.5892464,19.627833 L20.1828418,10.1534791 C20.6057194,9.65725646 20.6057194,8.86838966 20.1828418,8.372167 C19.7599643,7.87594433 19.0876973,7.87594433 18.6648198,8.372167 L11.8302353,16.9685885 Z",
    id: "Icon-Color",
    fill: "#50566E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.441f952d993f0c6645aa3d5f56679c07.svg";
export { ForwardRef as ReactComponent };